import LinkButton from "./LinkButton.jsx";

export default function NotFound({ navigate }) {
  return (
    <section className="mx-auto max-w-3xl px-4 py-20 text-center sm:px-6 lg:px-8">
      <h1 className="text-3xl font-black text-civic-navy">
        Page not found
      </h1>

      <p className="mt-3 text-slate-600">
        The page you requested does not exist.
      </p>

      <div className="mt-6">
        <LinkButton href="/" navigate={navigate}>
          Return home
        </LinkButton>
      </div>
    </section>
  );
}
